import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { KMCDepartmentLeftManu } from "../components/KMCDepartmentLeftManu";

const Emblem = () => {
  const { t } = useTranslation();
  return (
    <>
      <>
        {/* Slider */}
        <section id="hero" className="hero hero2">
          <LeftSocialMediaIconUI />

          <div className="carousel-item active">
            <img
              src="assets/img/inner-bg2.png"
              className="img-fluid"
              alt="alt"
            />
            <div className="container">
              <div className="section-main-heading2">
                <h4 className="fontSizeClass"> About Us - Emblem </h4>
              </div>
            </div>
          </div>
        </section>
        {/* End Slider */}

        <section className="section inner-pad1">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <div className="site-menu  min-height-400">
                  <KMCDepartmentLeftManu />
                </div>
              </div>
              <div className="col-lg-9">
                <div className="container">
                  <div className="row">
                    <div className="inner-title">
                      <h3 className="fontSizeClass"> {t("Emblem")} </h3>
                    </div>
                    <div className="col-lg-12 about-img2">
                      <img
                        src="assets/img/old.gif"
                        className="img-fluid"
                        alt="alt"
                      />
                      <p className="fontSizeClass">{t("Emblem_text")}</p>
                      <br />
                    </div>
                    <div className="col-lg-12 about-head1">
                      <div className="old-logo1">
                        <img
                          src="assets/img/lg.jpg"
                          className="img-fluid"
                          alt="alt"
                        />
                      </div>
                      <p className="fontSizeClass">{t("Emblem_text1")}</p>
                      <p className="fontSizeClass">{t("Emblem_text1a")}</p>
                      <p className="fontSizeClass">{t("Emblem_text2")}</p>
                      <p className="fontSizeClass">{t("Emblem_text3")}</p>
                      <p className="fontSizeClass">{t("Emblem_text4")}</p>
                      <p className="fontSizeClass">{t("Emblem_text5")}</p>
                      <p className="fontSizeClass">{t("Emblem_text6")}</p>
                      <p className="fontSizeClass">{t("Emblem_text7")}</p>
                      <p className="fontSizeClass">{t("Emblem_text8")}</p>
                      <p className="fontSizeClass">{t("Emblem_text9")}</p>
                      <p className="fontSizeClass">{t("Emblem_text10")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
};

export default Emblem;
